const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/comment/v1frontend/chat/search', { params })
  },
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/comment/v1frontend/chat/create', params)
  },
  list ({ state, commit, rootState }, params) {
    return rootState.axios.get('/comment/v1frontend/chat/list', { params })
  },
  view ({ state, commit, rootState }, params) {
    return rootState.axios.get('/comment/v1frontend/chat/view', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
